import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Select packages", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_free_subscriptions_form_field_member = _resolveComponent("free-subscriptions-form-field-member")!
  const _component_free_subscriptions_form_field_start_date = _resolveComponent("free-subscriptions-form-field-start-date")!
  const _component_free_subscriptions_form_field_end_date = _resolveComponent("free-subscriptions-form-field-end-date")!
  const _component_free_subscriptions_form_field_subscription_type = _resolveComponent("free-subscriptions-form-field-subscription-type")!
  const _component_free_subscriptions_form_field_process_type = _resolveComponent("free-subscriptions-form-field-process-type")!
  const _component_form_field_packages = _resolveComponent("form-field-packages")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_free_subscription_pick_member_dialog = _resolveComponent("free-subscription-pick-member-dialog")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_free_subscription_new_member_dialog = _resolveComponent("free-subscription-new-member-dialog")!
  const _component_free_subscription_search_for_member_dialog = _resolveComponent("free-subscription-search-for-member-dialog")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    greedy: "",
    onSubmit: _ctx.onSubmit,
    class: "q-gutter-md",
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_free_subscriptions_form_field_member, {
        modelValue: _ctx.memberModel.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.memberModel.email) = $event)),
        firstName: _ctx.memberModel.firstName,
        lastName: _ctx.memberModel.lastName,
        showHint: true,
        showPickMemberButton: true,
        onShowMemberDialog: _ctx.showMemberDialog
      }, null, 8, ["modelValue", "firstName", "lastName", "onShowMemberDialog"]),
      _createVNode(_component_free_subscriptions_form_field_start_date, {
        modelValue: _ctx.freeSubscriptionModel.startDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.freeSubscriptionModel.startDate) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_free_subscriptions_form_field_end_date, {
        modelValue: _ctx.freeSubscriptionModel.endDate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.freeSubscriptionModel.endDate) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_free_subscriptions_form_field_subscription_type, {
        modelValue: _ctx.freeSubscriptionModel.subscriptionType,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.freeSubscriptionModel.subscriptionType) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_free_subscriptions_form_field_process_type),
      _createVNode(_component_q_card, {
        class: "q-pa-lg q-mb-lg",
        flat: "",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_form_field_packages, {
            "hide-inactives": "",
            modelValue: _ctx.freeSubscriptionModel.packages,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.freeSubscriptionModel.packages) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showPickMemberDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPickMemberDialog) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_free_subscription_pick_member_dialog, {
            onNewMember: _ctx.onAddMember,
            onSearchForMember: _ctx.onSearchForMember
          }, null, 8, ["onNewMember", "onSearchForMember"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showAddMemberDialog,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showAddMemberDialog) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_free_subscription_new_member_dialog, { onPickAddedMember: _ctx.assignAddedMember }, null, 8, ["onPickAddedMember"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showSearchForMemberDialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showSearchForMemberDialog) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_free_subscription_search_for_member_dialog, { onPickMember: _ctx.assignAddedMember }, null, 8, ["onPickMember"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        label: "Add subscription",
        type: "submit",
        color: "primary",
        unelevated: "",
        "no-caps": ""
      }),
      _createVNode(_component_q_btn, {
        label: "Back to listing",
        to: { name: _ctx.FreeSubscriptionsRouteNames.LIST, query: { page: _ctx.route.query.page }, params: { restoreFilters: 1 } },
        color: "primary",
        outline: "",
        "no-caps": ""
      }, null, 8, ["to"])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}